module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-2-2ec2eab5df211bbb38979c0450562e82.gif";